export default {
  root: {},
  elevation1: {
    boxShadow: 'none'
  }
};
